import { BrandImageSchema } from "@redotech/redo-model/brand-types";
import { marketplaceType } from "@redotech/redo-model/catalog/catalog";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getMarketplaceVendorCounts = {
  name: "getMarketplaceVendorCounts" as const,
  input: z.object({ marketplaceType: createEnum(marketplaceType) }),
  output: z.object({
    vendorCounts: z.array(
      z.object({
        vendor: z.string(),
        image: BrandImageSchema.nullish(),
        category: z.string().optional(),
        count: z.number(),
      }),
    ),
  }),
};
